import React, { useState } from "react";
import Notification from "../../../components/ui/Notification";

import TypeTabs from "./components/TypeTabs";
import ContentForm from "./components/ContentForm";
import ItemsGrid from "./components/ItemsGrid";

import { useMenuItems } from "./hooks/useMenuItems";
import { uploadToCloudinary } from "./services/cloudinary.service";
import { createProduct, updateProduct, setProductActive, deleteProduct } from "./services/menuItems.service";

const ContentPage = () => {
  const [activeType, setActiveType] = useState("men");
  const [editingProduct, setEditingProduct] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [notif, setNotif] = useState({ type: "info", message: "" });

  const { filteredItems, loadingItems } = useMenuItems(activeType, setNotif);

  const handleCreate = async ({
    name,
    price,
    shenime,
    type,
    isActive,
    imageFile,
  }) => {
    setSubmitting(true);
    setNotif({ message: "" });

    try {
      const imageUrl = await uploadToCloudinary(imageFile);

      await createProduct({
        name,
        price,
        shenime: shenime || "",
        type,
        imageUrl,
        isActive,
      });

      setNotif({ type: "success", message: "Produkti u shtua me sukses." });
      return true;
    } catch (err) {
      setNotif({
        type: "error",
        message: err?.message || "Ndodhi një gabim gjatë ruajtjes.",
      });
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  const handleUpdate = async ({
    id,
    name,
    price,
    shenime,
    type,
    isActive,
    imageFile,
    existingImageUrl,
  }) => {
    setSubmitting(true);
    setNotif({ message: "" });
    try {
      const imageUrl = imageFile
        ? await uploadToCloudinary(imageFile)
        : (existingImageUrl || "");
      await updateProduct(id, {
        name,
        price,
        shenime: shenime || "",
        type,
        imageUrl,
        isActive,
      });
      setNotif({ type: "success", message: "Produkti u përditësua." });
      setEditingProduct(null);
      return true;
    } catch (err) {
      setNotif({
        type: "error",
        message: err?.message || "Ndodhi një gabim gjatë përditësimit.",
      });
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteProduct(id);
      setNotif({ type: "success", message: "Produkti u fshi." });
    } catch {
      setNotif({
        type: "error",
        message: "S’u arrit të fshihet produkti.",
      });
    }
  };

  const toggleActive = async (id, current) => {
    try {
      await setProductActive(id, !current);
    } catch {
      setNotif({
        type: "error",
        message: "S’u arrit të ndryshohet statusi i produktit.",
      });
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
        <div className="min-w-0">
          <h2 className="text-xl sm:text-2xl font-semibold text-[#000000]">
            Përmbajtja
          </h2>
          <p className="mt-1 text-sm text-[#a6a6a6]">
            Menaxho parfume për burra dhe për gra.
          </p>
        </div>
      </div>

      <Notification
        type={notif.type}
        message={notif.message}
        onClose={() => setNotif({ message: "" })}
      />

      <TypeTabs activeType={activeType} setActiveType={setActiveType} />

      <div className="grid gap-4 sm:gap-6 lg:grid-cols-5">
        <ContentForm
          activeType={activeType}
          onSubmit={editingProduct ? handleUpdate : handleCreate}
          submitting={submitting}
          setNotif={setNotif}
          editingProduct={editingProduct}
          onCancelEdit={() => setEditingProduct(null)}
        />

        <ItemsGrid
          activeType={activeType}
          filteredItems={filteredItems}
          loadingItems={loadingItems}
          onToggleActive={toggleActive}
          onDelete={handleDelete}
          onEdit={setEditingProduct}
        />
      </div>
    </div>
  );
};

export default ContentPage;
